import React from 'react'

interface TableActionColumnHeaderProps extends Omit<React.ThHTMLAttributes<HTMLTableCellElement>, 'className'> {
  accessibleLabel?: string;
}

export function TableActionColumnHeader ({ accessibleLabel = 'Actions', ...props }: TableActionColumnHeaderProps) {
  return (
    <th {...props} className='bg-white border-b border-gray-200'>
      <span className='sr-only'>{accessibleLabel}</span>
    </th>
  )
}

TableActionColumnHeader.displayName = 'Table.ActionColumnHeader'
